import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MainModal } from "../../../../components/modal/MainModal";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";
import Table from "../../../../components/coreUiTable/Table";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { cuFormat } from "../../../../components/coreUiTable/Format";
import ReactTooltip from "react-tooltip";
import { actionCreators } from "../redux/sagas/utilization";

const addTooltip = (header, formattedValue) => (
  <span data-tip={formattedValue} key={formattedValue}>
    {formattedValue}
  </span>
);

const rebuildTooltip = () => {
  setTimeout(() => {
    ReactTooltip.rebuild();
  }, 0);
};

const Modal = ({ isOpen, setOpenPopup, modalKey, modalTitle }) => {
  const dispatch = useDispatch();
  const isDetailsModalLoading = useSelector((state) => state.utilization.isDetailsModalLoading);
  const modalData = useSelector((state) => state.utilization.detailsModalData[modalKey] || {});
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    if (Object.keys(modalData).length === 0) {
      dispatch(actionCreators.fetchModalDetailsData({ modalKey }));
    }
  }, []);

  const close = () => {
    setOpenPopup(false);
  };

  const { tableData, dataPoints = [] } = modalData;
  return (
    <MainModal
      isOpen={isOpen}
      onClose={close}
      parentSelector=".utilization-module"
      headerText={modalTitle}
      headerCloseHandler={close}
      containerClassName="utilization-details-popup-body"
      renderFooter={() => {}}
      height="auto"
      width={950}
      isAdminPanel={false}
    >
      {isDetailsModalLoading ? (
        <LoadingAnimation />
      ) : tableData?.data?.length ? (
        <>
          <div className="data-points">
            {dataPoints.length > 0 && (
              <div className="data-points">
                {dataPoints.map(({ label, value }) => (
                  <div key={label} className="data-point">
                    <DataDisplay
                      size={36}
                      value={value}
                      label={label}
                      disableAnimation
                      type="money"
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
          <ReactTooltip effect="solid" id={modalKey} />
          <Table
            cName="utilization-details-table"
            pagination
            title=" "
            itemsPerPage={5}
            sorter
            table={tableData}
            onFilteredItemsChange={(data) => {
              rebuildTooltip();
              setFilteredData(data);
            }}
            scopedSlots={cuFormat({
              customFn: (header, formattedValue) => addTooltip(header, formattedValue),
              headers: tableData.colHeaders,
              columns: tableData.columns
            })}
            onPageChange={rebuildTooltip}
            underTableSlot={
              <table className="table coreUiTable" id="under-table-slot">
                <tbody>
                  <tr>
                    <td style={{ fontWeight: "bold" }}>Total</td>
                    <td style={{ fontWeight: "bold" }}>{filteredData.length}</td>
                  </tr>
                </tbody>
              </table>
            }
          />
        </>
      ) : (
        <p className="error">No data for selected period</p>
      )}
    </MainModal>
  );
};

export const DetailsModal = ({ label }) => {
  const [isOpen, setIsOpen] = useState(false);

  const modalKey = label.toLowerCase().replace(" ", "_");

  return (
    <>
      {isOpen && (
        <Modal isOpen={isOpen} setOpenPopup={setIsOpen} modalKey={modalKey} modalTitle={label} />
      )}
      <span
        className="glyphicon glyphicon-tags"
        onClick={() => {
          setIsOpen(true);
        }}
      />
    </>
  );
};
